// UtilContext.js

import React, { createContext, useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";

const UtilContext = createContext();

export function useUtil() {
  return useContext(UtilContext);
}

export const UtilProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);
  const [cookiePolicy, setCookiePolicy] = useState("none");

  const showLoader = () => {
    setLoader(true);
  };

  const hideLoader = () => {
    setLoader(false);
  };

  const updateCookiePolicy = (policy) => {
    setCookiePolicy(policy);
    Cookies.set("cookiePolicy", policy, { expires: 365 });
    console.log("Updated cookie policy:", policy);
  };

  const value = {
    loader,
    showLoader,
    hideLoader,
    cookiePolicy,
    updateCookiePolicy,
  };

  useEffect(() => {
    const savedPolicy = Cookies.get("cookiePolicy");
    console.log("savedPolicy from cookie: ", savedPolicy);
    if (savedPolicy) {
      setCookiePolicy(savedPolicy); // Update state with the saved policy
    }
  }, []); // Runs only once when the component mounts

  return <UtilContext.Provider value={value}>{children}</UtilContext.Provider>;
};
